
import { NgModule } from '@angular/core';
import { HammerModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import  'hammerjs';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LoginPageModule } from '../app/login/login.module';
import { HttpClientModule , HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InterceptorService } from '../app/Servicios/Interceptor/interceptor.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { NgxSoapModule } from 'ngx-soap';
import { provideFirebaseApp, getApp, initializeApp } from '@angular/fire/app';


@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [ 
    HttpClientModule,
    LoginPageModule,
    BrowserAnimationsModule, 
    HammerModule,
    IonicModule.forRoot(), 
    AppRoutingModule, 
    NgxSoapModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
  enabled: environment.production,
  // Register the ServiceWorker as soon as the app is stable
  // or after 30 seconds (whichever comes first).
  //registrationStrategy: 'registerWhenStable:30000'
})
  ],
    
  providers: [ 
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
